<template>
    <b-form-group :label="'delay_payment' | translate('global')" label-cols-xl="2" label-class="min-w-150"
                  :disabled="isDisabled">
    <b-form-radio-group class="mt-2"
                        :options="radioOptions"
                        v-model="isDetainedPayment"/>
  </b-form-group>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import statuses from '@/store/statuses';
import VuexTypes from '@/store/types/index';

const InvoiceTypes = VuexTypes.invoices;
export default {
  mounted() {},
  data() {
    return {
      isDisabled: true,
      isDetainedPayment: null,
      radioOptions: [
        { text: this.$t('no', 'global'), value: 0 },
        { text: this.$t('yes', 'global'), value: 1 },
      ],
    };
  },
  components: {},
  computed: {
    ...mapGetters('Invoices', [
      'invoiceUpdateData',
      'invoiceUpdateDetainedPayment',
    ]),
  },
  watch: {
    invoiceUpdateData: {
      immediate: true,
      handler: function () {
        if (this.invoiceUpdateData.status === statuses.LOADED) {
          const data = this.invoiceUpdateData.data;
          const actions = data ? data['invoice']
            ? data['invoice']['actions'] : {}
            : {};
          this.isDisabled = !actions['update_detained_payment'];
          this.isDetainedPayment = data['invoice'] ? data['invoice']['is_detained_payment'] ? 1 : 0 : null;
        }
      },
      deep: true
    },
    invoiceUpdateDetainedPayment: {
      handler: function () {
        if (this.invoiceUpdateDetainedPayment.status === statuses.LOADED) {
          this.alertSuccess();
        } else if (this.invoiceUpdateDetainedPayment.status === statuses.ERROR) {
          this.alertError();
        }
      },
      deep: true
    },
    isDetainedPayment: function () {
      const data = this.invoiceUpdateData.data;
      const originalStatus = data['invoice'] ? data['invoice']['is_detained_payment'] ? 1 : 0 : null;
      if (originalStatus !== null && Number(this.isDetainedPayment) !== Number(originalStatus)) {
        this.INVOICE_UPDATE_DETAINED_PAYMENT({
          invoiceId: this.$route.params.id,
          updateData: {
            is_detained_payment: this.isDetainedPayment
          }
        });
      }
    }
  },
  methods: {
    ...mapActions('Invoices', [
      InvoiceTypes.INVOICE_UPDATE_DETAINED_PAYMENT,
    ]),
  }
};
</script>
